module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-lukas-590022-f21111fd3b3e4c339cb39bd21b77cb6e.jpg";